<div class="ui-g form-container panel-div">
  <form [formGroup]="bookingTaxiForm" class="ui-g-12">
    <div class="ui-g">
      <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
        <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["general"]'>
          <div *ngFor="let ErrorMessage of packageApiError['general']">
            {{ErrorMessage.message}}
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_car_type</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-select [options]="carTypeOptions" formControlName="carType" (onChange)="changeCarType($event)">
            </p-select>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["vehicleTypeId"]'>
            <div *ngFor="let ErrorMessage of packageApiError['vehicleTypeId']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.carType.errors  && (bookingTaxiForm.controls.carType.dirty || bookingTaxiForm.controls.carType.touched)">
            <div [hidden]="!bookingTaxiForm.controls.carType.errors.required" translate>
              car_type
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_pickup_location</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" [placeholder]="label_pickup" id="pickme" name="pickme" pInputText formControlName="pickupLocation"
              appSearchLocation (setAddress)="setPickup($event)" (keyup)="pickupBit=true" (focus)='!packageApiError[0]["pickupLocationName"]=false' />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["pickupLocationName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['pickupLocationName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.pickupLocation.errors  && (bookingTaxiForm.controls.pickupLocation.dirty || bookingTaxiForm.controls.pickupLocation.touched)">
            <div [hidden]="!bookingTaxiForm.controls.pickupLocation.errors.required" translate>
              pickup_location
            </div>
          </div>
        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_drop_location</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" [placeholder]="label_drop" id="dropme" name="dropkme" pInputText formControlName="dropLocation"
              appSearchLocation (setAddress)="setDropUp($event)" (onchange)="driverAssignBit=true" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["dropLocationName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['dropLocationName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.dropLocation.errors  && (bookingTaxiForm.controls.dropLocation.dirty || bookingTaxiForm.controls.dropLocation.touched)">
            <div [hidden]="!bookingTaxiForm.controls.dropLocation.errors.required" translate>
              drop_location
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_pickup_date_time</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-datepicker formControlName="pickupDate" [defaultDate]="minDate" [minDate]="minDate" [readonlyInput]="true"
              dateFormat="{{dateFormat}}" [showTime]="true" [showIcon]="true" (onSelect)="pickupDateTimeSelected($event)">
            </p-datepicker>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["pickupDate"]'>
            <div *ngFor="let ErrorMessage of packageApiError['pickupDate']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.pickupDate.errors  && (bookingTaxiForm.controls.pickupDate.dirty || bookingTaxiForm.controls.pickupDate.touched)">
            <div [hidden]="!bookingTaxiForm.controls.pickupDate.errors.required" translate>
              booking_date
            </div>
          </div>
        </div>



        <div class="form-field ui-g-12 ui-md-4 ui-lg-4  ui-g-nopad">
          <div class="form-label lable-mobile-number">
            <label for="username" translate>label_mobile_no</label>
            <label class="asterisk">*</label>
          </div>
          <div class="ui-g-3  ui-inputgroup mobile-number">
            <span class="ui-inputgroup-addon">
              <i class="fa fa-plus"></i>
            </span>
            <input class="input-mobile-code" type="text" pInputText formControlName="phoneCode" placeholder="Code" />
          </div>

          <div class="form-control ui-g-9 mobile-number">
            <p-autoComplete class="assign" [suggestions]="passengerSearchTextResult" (completeMethod)="passengerSearch($event)"
              placeholder="Type to search passenger" field="phoneNum" formControlName="mobileNo" (onSelect)="onSelectMobileNumber($event)">
              <ng-template let-ref pTemplate="item">
                <span style="font-size:16px">{{ref.phoneNum}}</span>
              </ng-template>
            </p-autoComplete>
          </div>

          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["numCountryCode"]'>
            <div *ngFor="let ErrorMessage of packageApiError['numCountryCode']">
              {{ErrorMessage.message}}
            </div>
          </div>

          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["phoneNum"]'>
            <div *ngFor="let ErrorMessage of packageApiError['phoneNum']">
              {{ErrorMessage.message}}
            </div>
          </div>


          <div class="form-errors" *ngIf="bookingTaxiForm.controls.phoneCode.errors  && (bookingTaxiForm.controls.phoneCode.dirty || bookingTaxiForm.controls.phoneCode.touched)">
            <div [hidden]="!bookingTaxiForm.controls.phoneCode.errors.required" translate>
              country_code_required
            </div>
            <div [hidden]="!bookingTaxiForm.controls.phoneCode.errors.minlength" translate>
              country_code_invalid
            </div>
            <div [hidden]="!bookingTaxiForm.controls.phoneCode.errors.maxlength" translate>
              country_code_invalid
            </div>
            <div [hidden]="!bookingTaxiForm.controls.phoneCode.errors.pattern" translate>
              country_code_invalid
            </div>
          </div>


          <div class="form-errors" *ngIf="bookingTaxiForm.controls.mobileNo.errors  && (bookingTaxiForm.controls.mobileNo.dirty || bookingTaxiForm.controls.mobileNo.touched)">
            <div [hidden]="!bookingTaxiForm.controls.mobileNo.errors.required" translate>
              phone_invalid
            </div>
            <div [hidden]="!bookingTaxiForm.controls.mobileNo.errors.minlength" translate>
              phone_invalid
            </div>
            <div [hidden]="!bookingTaxiForm.controls.mobileNo.errors.maxlength" translate>
              max_length
            </div>
            <div [hidden]="!bookingTaxiForm.controls.mobileNo.errors.pattern" translate>
              number_pattern
            </div>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_email</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="email" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["phoneNum"]'>
            <div *ngFor="let ErrorMessage of packageApiError['phoneNum']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.email.errors  && (bookingTaxiForm.controls.email.dirty || bookingTaxiForm.controls.email.touched)">
            <div [hidden]="!bookingTaxiForm.controls.email.errors.required" translate>
              email_required
            </div>
            <div [hidden]="!bookingTaxiForm.controls.email.errors.pattern" translate>
              email_pattern
            </div>
          </div>
        </div>

      </div>
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_passenger_name</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="passengerName" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["passengerName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['passengerName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.passengerName.errors  && (bookingTaxiForm.controls.passengerName.dirty || bookingTaxiForm.controls.passengerName.touched)">
            <div [hidden]="!bookingTaxiForm.controls.passengerName.errors.required" translate>
              passenger_name
            </div>
            <div [hidden]="!bookingTaxiForm.controls.passengerName.errors.minlength" translate>
              min_length
            </div>
            <div [hidden]="!bookingTaxiForm.controls.passengerName.errors.pattern" translate>
              name_pattern
            </div>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="roomNum" translate>label_room_num</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="roomNum" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["roomNum"]'>
            <div *ngFor="let ErrorMessage of packageApiError['roomNum']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.roomNum.errors && (bookingTaxiForm.controls.roomNum.dirty || bookingTaxiForm.controls.roomNum.touched)">

            <div [hidden]="!bookingTaxiForm.controls.roomNum.errors.required" translate>
              lable_room_no_req
            </div>
            <div [hidden]="!bookingTaxiForm.controls.roomNum.errors.maxlength" translate>
              room_num_max_length
            </div>
          </div>
        </div>


        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_Hotels</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-select [options]="hotelList" formControlName="hotelNames">
            </p-select>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["hotelNames"]'>
            <div *ngFor="let ErrorMessage of packageApiError['hotelNames']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors" *ngIf="bookingTaxiForm.controls.hotelNames.errors  && (bookingTaxiForm.controls.hotelNames.dirty || bookingTaxiForm.controls.hotelNames.touched)">
            <div [hidden]="!bookingTaxiForm.controls.hotelNames.errors.required" translate>
              hotel_req
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g">



        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="username" translate>label_assign_driver</label>
          </div>
          <div class="form-control">
            <p-autoComplete class="assign" [suggestions]="searchTextResult" (completeMethod)="search($event)"
              placeholder="Type to search driver" field="name" formControlName="driverAssign" [dropdown]="true">
              <ng-template let-ref pTemplate="item">
                <span style="font-size:16px">{{ref.name}}</span>
                <span class="driver-eta">{{ref.eta}}</span>
              </ng-template>
            </p-autoComplete>
          </div>

        </div>
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="note" translate>label_note</label>
          </div>
          <div class="form-control">
            <input type="text" pInputText formControlName="note" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["note"]'>
            <div *ngFor="let ErrorMessage of packageApiError['note']">
              {{ErrorMessage.message}}
            </div>
          </div>

        </div>
        <div [hidden]="!isCorporatePassenger" class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-label">
            <label for="note" translate>label_corporate_name</label>
          </div>
          <div class="disguise-read-only">
            {{selectedPassengerCorporate}}
          </div>
        </div>

      </div>
      <div class="ui-g">
        <div class="form-field ui-g-12 ui-md-4 ui-lg-4">
          <div class="form-control" style="padding-top: 6%">
            <p-checkbox class="vip-chk" name="VPassenger" binary="true" label="VIP Passenger" formControlName="VIPPassenger"></p-checkbox>
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["vip"]'>
            <div *ngFor="let ErrorMessage of packageApiError['vip']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>
      </div>

      <div class="form-buttons ui-g-12 ui-g-nopad">
        <button class="negative-button" pButton type="button" icon="fa-close" [label]="labelCancel" (click)="cancel()"></button>
        <button pButton type="button" [label]="labelSave" icon="fa-check" [disabled]="!bookingTaxiForm.valid" (click)="addbooking()"></button>
      </div>
    </div>
    <p-toast key="message"></p-toast>
  </form>
</div>